const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN || "avoid-failing", // if empty, throws
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT || "",
    code_version: process.env.REACT_APP_COMMIT_ID || "",
    branch: process.env.REACT_APP_BRANCH || "",
    root: `${window.location.href}/static/js/`,
    //trace_id: 'abc',
    client: {
      javascript: {
        source_map_enabled: true,
        //guess_uncaught_frames: true
      },
    },
    server: {},
  },
};

export default rollbarConfig;
